import React, { Component } from 'react';
import cookie from '../../src/cookie.png';
import { Button } from '@blueprintjs/core';
import{withRouter,Link} from 'react-router-dom';

export default class Welcome extends Component
{
    render()
    {
        return <div className = "welcome">
            <div className= "welcometext">欢迎来到小说研究所<br/>
            在这，我会手把手教你写小说
            </div>
            <img src={cookie} className="cookiepicture" alt="cookie" />
            <div className= "asktext">请问你是第一次来吗？<br/>想听简单介绍吗？</div>

            <Link to="/introduce"><Button icon="arrow-right" className="Button" minimal={true}  >要听，我什么也不知道</Button></Link>
            <br/>
            <br/>
            <br/>
           
            <Link to="/twice"><Button icon="arrow-right" className="Button" minimal={true}>少废话，我已经听过了</Button></Link>
            </div>;


    }
} 